/* eslint-disable react/no-danger */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

const AccordionItem = ({
  className,
  header,
  content,
  onClick,
  opened,
  style,
  arrowIcons,
  arrowIconColor,
  boldHeader,
}) => (
  <div className={`w-100 d-flex flex-column rounded-extra px-4 py-4 ${className}`} style={style}>
    <div
      role="button"
      tabIndex={-1}
      onClick={onClick}
      onKeyDown={onClick}
      className="d-flex flex-row justify-content-between align-items-center ">
      {typeof header === 'string' && (
        <div
          className={`${boldHeader ? 'text-bold' : ''} text-dark text-f5`}
          dangerouslySetInnerHTML={{ __html: header }}
        />
      )}
      {typeof header !== 'string' && (
        <div className={`${boldHeader ? 'text-bold' : ''} text-dark text-f5`}>{header}</div>
      )}

      {!opened && (
        <div>
          {!arrowIcons && <img src="./assets/icons/plus.svg" alt="plus" />}
          {arrowIcons && <i className={`icon-arrow-down-navigation ${arrowIconColor} text-f4`} />}
        </div>
      )}
      {opened && (
        <div style={{ transform: arrowIcons ? 'rotate(180deg)' : '' }}>
          {!arrowIcons && <img src="./assets/icons/minus.svg" alt="plus" />}
          {arrowIcons && <i className={`icon-arrow-down-navigation ${arrowIconColor} text-f4`} />}
        </div>
      )}
    </div>
    {opened && typeof content === 'string' && (
      <div
        className={`mt-3 text-dark text-f6 ${isMobile ? 'w-100' : 'w-75'}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )}
    {opened && typeof content !== 'string' && (
      <div className="mt-3 text-dark text-f6 w-100">{content}</div>
    )}
  </div>
);

AccordionItem.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onClick: PropTypes.func.isRequired,
  opened: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object]),
  arrowIcons: PropTypes.bool,
  arrowIconColor: PropTypes.string,
  boldHeader: PropTypes.bool,
};

AccordionItem.defaultProps = {
  className: null,
  style: null,
  opened: false,
  arrowIcons: false,
  boldHeader: true,
  arrowIconColor: 'text-info',
};

export default AccordionItem;
